module.exports = __webpack_public_path__ + "img/public_institution.82c7af84.jpg";